import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import {
  Bell,
  CheckCircle,
  CircleNotch,
  Database,
  Export,
  PaperPlaneRight,
  WebhooksLogo
} from '@phosphor-icons/react';

const OutputNode = memo(({ data, selected }) => {
  const iconMap = {
    text: PaperPlaneRight,
    json: Database,
    file: Export,
    notification: Bell,
    webhook: WebhooksLogo,
    audio: PaperPlaneRight,
    api_call: WebhooksLogo
  };

  const Icon = iconMap[data.outputType] || PaperPlaneRight;
  const executionStatus = data.executionStatus;

  return (
    <div
      data-testid="flow-node-output"
      className={`
        group relative min-w-[180px] max-w-[220px] rounded-[10px] overflow-hidden
        bg-[var(--surface-2)] border-l-[3px] border transition-all duration-150
        ${executionStatus === 'processing'
          ? 'border-l-teal-400 border-teal-400/40'
          : executionStatus === 'success'
            ? 'border-l-emerald-400 border-emerald-400/40'
            : selected
              ? 'border-l-teal-400 border-[var(--border-strong)]'
              : 'border-l-teal-500 border-[var(--border-default)] hover:border-[var(--border-strong)]'}
      `}
    >
      <Handle
        type="target"
        position={Position.Left}
        className="!w-[10px] !h-[10px] !border-2 !left-[-6px] transition-colors
          !bg-teal-400 !border-teal-300/50 hover:!bg-teal-300"
      />

      {/* Header */}
      <div className="flex items-center gap-2.5 px-3 pt-3 pb-2">
        <div className="flex-shrink-0 w-[34px] h-[34px] rounded-lg border flex items-center justify-center
          bg-teal-500/10 border-teal-500/20"
        >
          {executionStatus === 'processing' ? (
            <CircleNotch size={20} weight="bold" className="text-teal-400 animate-spin" />
          ) : executionStatus === 'success' ? (
            <CheckCircle size={20} weight="duotone" className="text-emerald-400" />
          ) : (
            <Icon size={20} weight="duotone" className="text-teal-400" />
          )}
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-[13px] font-semibold text-white truncate leading-tight">{data.label}</p>
          <span className="text-[10px] text-teal-400/60 font-medium uppercase tracking-wider">Output</span>
        </div>
      </div>

      {/* Body - status */}
      <div className="px-3 pb-2.5 pt-0.5 border-t border-white/[0.04]">
        {executionStatus === 'processing' ? (
          <span className="text-[10px] text-teal-400 font-medium animate-pulse">Generating...</span>
        ) : executionStatus === 'success' ? (
          <span className="text-[10px] text-emerald-400 font-semibold">Complete</span>
        ) : (
          <span className="text-[10px] text-slate-500">Ready</span>
        )}
      </div>
    </div>
  );
});

OutputNode.displayName = 'OutputNode';
export default OutputNode;
